module.exports = __webpack_public_path__ + "static/media/kids-loving.78b06997.jpg";